<template>
  <BackendTable :query="query" :endPoint="'jobs/'" @pageChange="(p) => $emit('pageChange', p)">
    <template v-slot="{ row }">
      <b-table-column field="id" label="ID" width="40" numeric>
          {{ row.id }}
      </b-table-column>

      <b-table-column field="created" label="Published">
          {{ $moment(row.created).fromNow() }}
          <b-tag rounded type="is-primary"
            v-if="$moment().diff($moment(row.created), 'days') < 7">
            New
          </b-tag>
      </b-table-column>

      <b-table-column field="employment_type" label="Position">
          {{ row.employment_type }}
      </b-table-column>

      <b-table-column field="skills" label="Skills">
          <b-tag rounded type="is-info"
            v-for="(s, i) in row.skills"
            :key="`${row.id}-${s}-${i}`">
            {{s}}
          </b-tag>
      </b-table-column>

      <b-table-column field="salary" label="Payment">
          <b-tag rounded type="is-success">
            {{ row.salary | money }}
          </b-tag>
      </b-table-column>

      <b-table-column label="From - To" centered>
          <b-tag rounded>
            {{ row.from_date }}
          </b-tag>
          -
          <b-tag rounded class="tag">
            {{ row.to_date || 'N/A' }}
          </b-tag>
      </b-table-column>

      <b-table-column label="Country">
        {{ row.country }}
      </b-table-column>

      <b-table-column label="Vessel">
        {{ row.vessel_size_ft }}ft ({{row.vessel_size_ft | toMeters}}m)
      </b-table-column>

      <b-table-column centered label="Details">
        <router-link
          class="button is-primary"
          tag="a"
          :to="{name:'job-view', params: {id: row.id}}">
          Details
        </router-link>
      </b-table-column>
    </template>
  </BackendTable>
</template>

<script>
import BackendTable from './BackendTable';


export default {
  components: {
    BackendTable,
  },

  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },

};
</script>
